<template>
  <div class="physioPowerEdit" v-loading="loading">
    <el-form ref="editForm" class="form" :model="form" :rules="rules" label-width="130px">
      <div class="form_row">
        <el-form-item label="医生姓名：">
          <div class="form_text">{{ form.doctorName }}</div>
        </el-form-item>
      </div>
      <div class="form_row">
        <el-form-item label="可执行项目：">
          <el-cascader
            ref="categoryCascader"
            class="form_input"
            v-model="form.doctorRelevancesSelect"
            :options="categoryList"
            @change="doctorRelevancesChange">
          </el-cascader>
          <el-table
            class="form_table"
            :data="form.doctorRelevances"
            max-height="300">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="小类" prop="secondCategory.physioLabel" min-width="180"></el-table-column>
            <el-table-column label="归属大类" prop="firstCategory.physioLabel" min-width="180"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="doctorRelevancesDelete(scope.row.secondCategory.categoryId)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
      <div class="form_row">
        <el-form-item label="时长系数：">
          <el-input class="form_input" v-model="form.globalConfig.durationFactor" placeholder="请输入执行时长系数" @input="durationFactorInput"></el-input>
        </el-form-item>
      </div>
      <div class="form_row">
        <el-form-item label="项目执行人：">
          <el-radio-group class="form_radio_group" v-model="form.executeDoctorConfig.executeType" @input="executeTypeChange">
            <el-radio :label="1">本人执行</el-radio>
            <el-radio :label="2">指定执行人员（医生/理疗师）</el-radio>
            <el-radio :label="3">不指定</el-radio>
          </el-radio-group>
          <div v-if="form.executeDoctorConfig.executeType === 2">
            <el-select class="form_input" v-model="form.executeDoctorConfig.executeDoctorRelevancesSelect" placeholder="请选择" filterable @change="executeDoctorRelevancesChange">
              <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
            </el-select>
            <el-table
              class="form_table"
              :data="form.executeDoctorConfig.executeDoctorRelevances"
              max-height="300">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column label="姓名" prop="executeDoctorName" min-width="180"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="executeDoctorRelevancesDelete(scope.row.executeDoctorId)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </div>
      <div class="form_row">
        <el-form-item label="预约时长：" prop="globalConfig.splitTime">
          <el-select class="form_input" v-model="form.globalConfig.splitTime" clearable placeholder="请选择">
            <el-option v-for="item in splitTimeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="form_row">
        <el-form-item label="小程序预约项目：">
          <el-select class="form_input" v-model="form.appletConfigsSelect" filterable remote :remote-method="remoteProcutionList" placeholder="请输入选择" clearable @change="productChange">
            <el-option v-for="item in productList" :key="item.spuId" class="product_option" :label="item.physioName" :value="item.spuId">
              <span class="product_option_name">{{ item.physioName }}</span>
              <span class="product_option_artNo">{{ item.artNo }}</span>
            </el-option>
          </el-select>
          <el-table
            class="form_table"
            :data="form.appletConfigs"
            max-height="300">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="SPU" prop="spu" min-width="100"></el-table-column>
            <el-table-column label="货号" prop="artNo" min-width="120"></el-table-column>
            <el-table-column label="项目名称" prop="physioKindName" min-width="180"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="appletConfigsDelete(scope.row.spu)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
    </el-form>
    <div class="footer_seat">
      <div class="footer">
        <div class="footer_btn footer_btn_cannel" @click="cannel">取消</div>
        <div class="footer_btn footer_btn_save" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getPhysioCategoryList, getPhysioPowerDetail, postPhysioPower, getPhysioProcutions } from '@/api/physio.js'

  export default {
    name: 'physioPowerEdit',
    data () {
      return {
        loading: true,
        categoryList: [],
        doctorOptions: [],
        splitTimeList: [
          { label: '按一小时预约', value: 60 },
          { label: '按半小时预约', value: 30 }
        ],
        productList: [],
        rules: {
          'globalConfig.splitTime': [{ required: true, message: '请选择预约时长', trigger: 'change' }]
        },
        form: {
          doctorId: '',
          doctorName: '',
          doctorRelevancesSelect: [],
          doctorRelevances: [],
          executeDoctorConfig: {
            executeType: 1,
            executeDoctorRelevancesSelect: '',
            executeDoctorRelevances: []
          },
          globalConfig: {
            durationFactor: 1,
            splitTime: 60
          },
          appletConfigsSelect: '',
          appletConfigs: []
        }
      }
    },
    created () {
      this.form.doctorId = this.$route.params.id
      this.getCategoryList()
      this.$getDoctorOptions()
      this.getDetail()
    },
    methods: {
      async getCategoryList () {
        const res = await getPhysioCategoryList()
        if (res.code === 200) {
          let list = res.data.filter(v => v.level === 1).map(v => {
            return {
              label: v.physioLabel,
              value: v.id,
              children: []
            }
          })
          const secondList = res.data.filter(v => v.level === 2).map(v => {
            return {
              parentId: v.parentId,
              label: v.physioLabel,
              value: v.id
            }
          })
          secondList.forEach(second => {
            const first = list.find(v => v.value === second.parentId)
            if (first) {
              first.children.push({
                parentId: first.value,
                parentIdName: first.label,
                label: second.label,
                value: second.value
              })
            }
          })
          this.categoryList = list
        }
      },
      async getDetail () {
        this.loading = true
        const res = await getPhysioPowerDetail({ doctorId: this.form.doctorId })
        this.loading = false
        if (res.code === 200) {
          this.form.doctorName = res.data.doctorName || ''
          this.form.doctorRelevances = res.data.doctorRelevances || []
          this.form.executeDoctorConfig.executeType = res.data.executeDoctorConfig && res.data.executeDoctorConfig.executeType || 1
          this.form.executeDoctorConfig.executeDoctorRelevances = res.data.executeDoctorConfig && res.data.executeDoctorConfig.executeDoctorRelevances || []
          this.form.globalConfig.durationFactor = res.data.globalConfig && res.data.globalConfig.durationFactor
          this.form.globalConfig.splitTime = res.data.globalConfig && res.data.globalConfig.splitTime
          this.form.appletConfigs = res.data.appletConfigs || []
        }
      },
      doctorRelevancesChange () {
        const node = this.$refs['categoryCascader'].getCheckedNodes()[0]
        const info = {
          firstCategory: {
            categoryId: node.parent.value,
            physioLabel: node.parent.label
          },
          secondCategory: {
            categoryId: node.value,
            physioLabel: node.label
          }
        }
        const isExist = this.form.doctorRelevances.some(v => v.secondCategory.categoryId === info.secondCategory.categoryId)
        if (!isExist) {
          this.form.doctorRelevances.push(info)
        } else {
          this.$message.error('该分类已添加')
        }
        this.form.doctorRelevancesSelect = []
      },
      doctorRelevancesDelete (secondCategoryId) {
        const index = this.form.doctorRelevances.findIndex(v => v.secondCategory.categoryId === secondCategoryId)
        if (index > -1) {
          this.form.doctorRelevances.splice(index, 1)
        }
      },
      durationFactorInput (value) {
        let result = value.replace(/[^\d.]/g, '')
          .replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
          .replace(/^(\-*)(\d+)\.(\d\d).*$/, '$1$2.$3')
        if (result.startsWith('-')) {
          result = result.substring(1)
        }
        this.form.globalConfig.durationFactor = result
      },
      executeTypeChange () {
        this.form.executeDoctorConfig.executeDoctorRelevances = []
      },
      executeDoctorRelevancesChange (doctorId) {
        const doctor = this.doctorOptions.find(v => v.doctorId === doctorId)
        if (doctor) {
          const isExist = this.form.executeDoctorConfig.executeDoctorRelevances.some(v => v.executeDoctorId === doctorId)
          if (!isExist) {
            this.form.executeDoctorConfig.executeDoctorRelevances.push({
              executeDoctorId: doctor.doctorId,
              executeDoctorName: doctor.doctorName
            })
          } else {
            this.$message.error('该医生已添加')
          }
          this.form.executeDoctorConfig.executeDoctorRelevancesSelect = ''
          }
      },
      executeDoctorRelevancesDelete (doctorId) {
        const index = this.form.executeDoctorConfig.executeDoctorRelevances.findIndex(v => v.executeDoctorId === doctorId)
        if (index > -1) {
          this.form.executeDoctorConfig.executeDoctorRelevances.splice(index, 1)
        }
      },
      async remoteProcutionList (name) {
        if (![null, undefined, ''].includes(name)) {
          const res = await getPhysioProcutions({ pageNum: 1, pageSize: 1000, physioName: name, searchMeiTuan: 2 })
          if (res.code === 200) {
            this.productList = res.rows || []
          }
        } else {
          this.productList = []
        }
      },
      productChange () {
        const product = this.productList.find(v => v.spuId === this.form.appletConfigsSelect)
        const isExist = this.form.appletConfigs.some(v => v.spu === product.spuId)
        if (!isExist) {
          this.form.appletConfigs.push({
            spu: product.spuId,
            artNo: product.artNo,
            physioKindName: product.physioName
          })
        } else {
          this.$message.error('该项目已添加')
        }
        this.form.appletConfigsSelect = ''
      },
      appletConfigsDelete (spu) {
        const index = this.form.appletConfigs.findIndex(v => v.spu === spu)
        if (index > -1) {
          this.form.appletConfigs.splice(index, 1)
        }
      },
      cannel () {
        this.$router.back()
      },
      async save () {
        this.$refs['editForm'].validate(async valid => {
          if (valid) {
            if (this.form.executeDoctorConfig.executeType === 2 && this.form.executeDoctorConfig.executeDoctorRelevances.length === 0) {
              this.$message.error('至少选择一个执行人员')
              return false
            }
            if (['', null, undefined].includes(this.form.globalConfig.durationFactor) || !(this.form.globalConfig.durationFactor > 0 && this.form.globalConfig.durationFactor <= 5)) {
              this.$message.error('请输入有效的时长系数，时长系数为0-5之间的两位小数')
              return false
            }
            this.loading = true
            const res = await postPhysioPower(this.form)
            this.loading = false
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$router.back()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioPowerEdit {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 20px;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .form {
    overflow: hidden;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_radio_group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
  }

  .form_radio_group /deep/ .el-radio {
    margin-right: 16px;
  }

  .form_radio_group /deep/ .el-radio__label {
    padding-left: 8px;
  }

  .form_text {
    box-sizing: border-box;
    padding: 0 15px;
    width: 360px;
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    color: #A8ABB2;
    background-color: #F5F7FA;
    border: 1px solid #d3d3d5;
    border-radius: 2px;
  }

  .form_input {
    width: 360px;
  }

  .product_option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .product_option_name {
    width: 240px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .product_option_artNo {
    flex-shrink: 0;
  }

  .form_table {
    margin: 12px 0 0 0;
    width: 600px;
    border: 1px solid #EBEAEE;
  }

  .footer_seat {
    width: 100%;
    height: 64px;
  }

  .footer {
    position: fixed;
    z-index: 2;
    bottom: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 64px;
    background-color: #FFFFFF;
    box-shadow: 0px -4px 8px 0px rgba(29,33,41,0.06);
  }

  .footer_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 32px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }

  .footer_btn+.footer_btn {
    margin: 0 0 0 8px;
  }

  .footer_btn_cannel {
    color: #291D22;
    background-color: #FFFFFF;
    border: 1px solid #C9CDD4;
  }

  .footer_btn_save {
    color: #FFFFFF;
    background-color: #1890FF;
  }
</style>